import { render, staticRenderFns } from "./AddBrandComponent.vue?vue&type=template&id=8ad4e9d2&scoped=true"
import script from "./AddBrandComponent.vue?vue&type=script&lang=js"
export * from "./AddBrandComponent.vue?vue&type=script&lang=js"
import style0 from "./AddBrandComponent.vue?vue&type=style&index=0&id=8ad4e9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad4e9d2",
  null
  
)

export default component.exports